import $ from 'jquery';
import { showPopup } from '@bingads-webui/automatic-positioning-popover';
import { LabelsPopupContentView } from './content-view';
import { triggerFilter, navigateToManagePage, filterOnLabelClick } from './label-filter-util';

/**
 * Show labels content in popup format, and handle the labels click event
 *
 * @param {Object} param - An object containing these default options for view:
 * @param {Object} param.i18n - the localization settings, by default return the provided key
 * @param {String} param.entityType - entity type, such as 'campaign'
 * @param {String} param.entityName the name of entity to show labels popup
 * @param {jQuery} param.anchor - the element as position base for popup position
 * @param {Object[]} param.labels - the labels content, in the format of
 *    {Id, Name, Description}
 * @param {Object} param.grid - the projection grid
 * @param {Object} param.router - the router
 * @param {Object} param.router.navigateToRoute - the route navigate function
 * @return {Promise} promise
 */
export function showLabelsPopup({
  labels,
  entityType,
  entityName,
  container = $('.grid-and-disclaim-container'),
  event,
  i18n,
  grid,
  router,
  filterService,
  isMCCLabelEnabled,
  groupClass = 'grid-group-other',
}) {
  const contentView = new LabelsPopupContentView({
    i18n,
    labels,
    entityType,
    entityName,
    isMCCLabelEnabled,
  });

  const popupOptions = {
    positioningMethod: 'fit',
    positioningOptions: {
      threshold: 0.5,
    },
    classes: ['popup--labels', groupClass],
    contentView,
    entityType,
    entityName,
    container,
  };

  const {
    top, left, height, width,
  } = $(event.target)[0].getBoundingClientRect();

  const uiNextVirtualOffset = container.offset();

  popupOptions.positioningOptions.anchorPosition = {
    height,
    width,
    left: left - uiNextVirtualOffset.left,
    top: top - uiNextVirtualOffset.top,
  };


  return showPopup(popupOptions).then((action) => {
    if (action.name === 'manage') {
      return navigateToManagePage(router);
    } else if (action.name === 'filter') {
      return triggerFilter(labels, grid, true, filterService, isMCCLabelEnabled);
    } else if (action.name === 'filterLabel') {
      return filterOnLabelClick(action.event, labels, grid, filterService, isMCCLabelEnabled);
    }

    return undefined;
  });
}
